// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"f5cf42ea","247":"28661293","627":"9f0b0aca","653":"0fa9c4d2","834":"4a12a2e9","867":"5867002a","923":"48d1988b","938":"63fbc34b"}[chunkId] + ".chunk.js";
};